import { render, staticRenderFns } from "./SalesDigitalListTop.vue?vue&type=template&id=ef2b4246&scoped=true&"
import script from "./SalesDigitalListTop.vue?vue&type=script&lang=js&"
export * from "./SalesDigitalListTop.vue?vue&type=script&lang=js&"
import style0 from "./SalesDigitalListTop.vue?vue&type=style&index=0&id=ef2b4246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2b4246",
  null
  
)

export default component.exports